module.exports = __webpack_public_path__ + "static/media/win.e55b8d80.gif";